import { render, staticRenderFns } from "./Petition.vue?vue&type=template&id=7db2dec4&scoped=true"
import script from "./Petition.vue?vue&type=script&lang=js"
export * from "./Petition.vue?vue&type=script&lang=js"
import style0 from "./Petition.vue?vue&type=style&index=0&id=7db2dec4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db2dec4",
  null
  
)

export default component.exports